import axios from "axios";
export default {
  namespaced: true,
  state: {

  },
  getters: {

  },
  mutations: {

  },
  actions: {
    async loadMyLesson(){
      return await axios.get('/employee/my-lessons')
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    },
    async loadLesson( _, params){
      return await axios.get('/employee/lessons', { params })
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    },
    async loadLessonDetail( _, slug){
      return await axios.get(`/employee/lessons/${slug}`)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    }
  },
};